import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Taste"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 3V4.5H6V10.5C6 13.8137 8.68629 16.5 12 16.5C15.3137 16.5 18 13.8137 18 10.5V4.5H21V3H3ZM16.5 10.5C16.5 12.9853 14.4853 15 12 15C9.51472 15 7.5 12.9853 7.5 10.5V4.5H11.25V10.5H12.75V4.5H16.5V10.5ZM8.25 19.5H9.75V21H8.25V19.5ZM5.25 18H6.75V19.5H5.25V18ZM11.25 18H12.75V19.5H11.25V18ZM14.25 19.5H15.75V21H14.25V19.5ZM17.25 18H18.75V19.5H17.25V18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Taste.vue"]]);
